window.global = window;
window.process = {
  env: { DEBUG: undefined },
  version: '1',
};
